<template>
    <div
        class="order-detail-page"
        :class="{ 'order-detail-page--mobile': ebkMobile }"
    >
        <page-breadcrumb :items="pageBreadcrumbItems" :mobile="ebkMobile" />
        <div>
            <el-card class="box-card" :body-style="bodyStyle">
                <div slot="header" class="order-detail-head clearfix ta-l">
                    <span class="fz-big fb order-detail-head__title">{{
                        detail.res_name
                    }}</span>
                    <div class="order-detail-head__actions">
                        <div
                            v-if="showPendingSupplierActions"
                            class="order-detail-head__btn-row"
                        >
                            <el-button
                                type="primary"
                                size="small"
                                class="order-detail-action-btn"
                                @click.stop="confirmOrder"
                                >确认订单</el-button
                            >
                            <el-button
                                type="danger"
                                size="small"
                                class="order-detail-action-btn"
                                @click.stop="confirmOrderNo"
                                >驳回订单</el-button
                            >
                        </div>
                        <el-button
                            v-if="showCaiNoticeConfirmBtn"
                            type="danger"
                            size="small"
                            class="order-detail-action-btn"
                            @click.stop="confirmationCancelEdit"
                            >确认已知悉</el-button
                        >
                    </div>
                </div>
                <div>
                    <el-descriptions
                        class="margin-top"
                        title=""
                        :column="descColumns"
                        :direction="descDirection"
                        size="small"
                        border
                    >
                        <el-descriptions-item>
                            <template slot="label">
                                <i class="el-icon-office-building"></i>
                                酒店位置
                            </template>
                            {{ detail.res_adress }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                <i class="el-icon-phone"></i>
                                酒店电话
                            </template>
                            {{
                                detail.res_phone ? detail.res_phone : "暂无电话"
                            }}
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
            </el-card>
        </div>
        <div class="mt-3">
            <div class="column wrap jc-sb">
                <div>
                    <el-card class="box-card" :body-style="bodyStyle">
                        <div slot="header" class="clearfix ta-l">
                            <span>订单信息</span>
                        </div>
                        <div>
                            <el-descriptions
                                class="margin-top"
                                title=""
                                :column="descColumns"
                                :direction="descDirection"
                                size="small"
                                border
                            >
                                <el-descriptions-item>
                                    <template slot="label">
                                        <i class="el-icon-document"></i>
                                        订单号
                                    </template>
                                    <span class="od-key-em">{{
                                        detail.order_no || "—"
                                    }}</span>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <i class="el-icon-document-checked"></i>
                                        对单号
                                    </template>
                                    <div>
                                        <span class="od-key-em">{{
                                            detail.cai_order_no || "—"
                                        }}</span>
                                        <i
                                            v-if="canMaintainHotel"
                                            class="
                                                el-icon-edit
                                                el-input__icon
                                                cur-p
                                            "
                                            title="修改对单号"
                                            @click.stop="openCaiNo"
                                        ></i>
                                    </div>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <i class="el-icon-tickets"></i>
                                        酒店确认号
                                    </template>
                                    <div>
                                        <span class="od-key-em">{{
                                            detail.psm_no || "—"
                                        }}</span>
                                        <i
                                            v-if="canMaintainHotel"
                                            class="
                                                el-icon-edit
                                                el-input__icon
                                                cur-p
                                            "
                                            title="修改酒店确认号"
                                            @click.stop="openPsmNo"
                                        ></i>
                                    </div>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <i class="el-icon-connection"></i>
                                        订单状态
                                    </template>
                                    <span
                                        class="od-status-badge"
                                        :class="orderStatusInfo.cls"
                                        >{{ orderStatusInfo.text }}</span
                                    >
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <i class="el-icon-s-finance"></i>
                                        结算总价
                                    </template>
                                    <span class="od-key-money"
                                        >￥{{ detail.o_fu_money }}</span
                                    >
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <i class="el-icon-s-fold"></i>
                                        结算类型
                                    </template>
                                    {{ settlementTypeText }}
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <i class="el-icon-message-solid"></i>
                                        提醒
                                    </template>
                                    <div class="notice">
                                        价格保密，发票由航阳开具，退改请联系航阳
                                    </div>
                                    <div class="fc-m">4000520552</div>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <i class="el-icon-tickets"></i>
                                        备注
                                    </template>
                                    {{
                                        detail.order_remark
                                            ? detail.order_remark
                                            : "暂无备注"
                                    }}
                                </el-descriptions-item>
                            </el-descriptions>
                        </div>
                    </el-card>
                </div>
                <div>
                    <el-card class="box-card" :body-style="bodyStyle">
                        <div slot="header" class="clearfix ta-l">
                            <span>入住信息</span>
                        </div>
                        <div>
                            <el-descriptions
                                class="margin-top"
                                title=""
                                :column="descColumns"
                                :direction="descDirection"
                                size="small"
                                border
                            >
                                <el-descriptions-item>
                                    <template slot="label">
                                        <i class="el-icon-menu"></i>
                                        产品政策
                                    </template>
                                    {{ detail.house_type_name }}/{{
                                        detail.policy_name
                                    }}
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <i class="el-icon-milk-tea"></i>
                                        早餐数量
                                    </template>
                                    <span v-if="detail.breakfast_count == 0"
                                        >无早</span
                                    >
                                    <span
                                        v-else-if="detail.breakfast_count == 1"
                                        >单早</span
                                    >
                                    <span
                                        v-else-if="detail.breakfast_count == 2"
                                        >双早</span
                                    >
                                    <span
                                        v-else-if="detail.breakfast_count == 3"
                                        >三份早餐</span
                                    >
                                    <span
                                        v-else-if="detail.breakfast_count == 4"
                                        >四份早餐</span
                                    >
                                    <span v-else>含早</span>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <i class="el-icon-school"></i>
                                        入住间数
                                    </template>
                                    {{ detail.rooms_count }}间
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <i class="el-icon-table-lamp"></i>
                                        入离日期
                                    </template>
                                    <span class="od-key-date">{{
                                        timestampToTime(detail.check_in_date)
                                    }}</span>
                                    ~
                                    <span class="od-key-date">{{
                                        timestampToTime(detail.check_out_date)
                                    }}</span>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <i class="el-icon-user"></i>
                                        入住人
                                    </template>
                                    <span class="od-key-contact">{{
                                        detail.psg_name || "—"
                                    }}</span>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <i class="el-icon-s-custom"></i>
                                        联系人
                                    </template>
                                    <span class="od-key-contact">{{
                                        detail.contact_name || "—"
                                    }}</span>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <i class="el-icon-mobile-phone"></i>
                                        联系人电话
                                    </template>
                                    <span class="od-key-contact">{{
                                        detail.contact_mobile || "—"
                                    }}</span>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <i class="el-icon-s-management"></i>
                                        取消规则
                                    </template>
                                    {{ detail.cancelpolicy_detail }}
                                </el-descriptions-item>
                            </el-descriptions>
                        </div>
                    </el-card>
                </div>
            </div>
        </div>
        <div class="mt-3">
            <el-card class="box-card" :body-style="bodyStyle">
                <div slot="header" class="clearfix ta-l row ai-c">
                    <span><i class="el-icon-user mr-1"></i>入住人 / 旅客</span>
                </div>
                <template v-if="traveller.length">
                    <div v-show="!ebkMobile" class="table-scroll-x">
                        <el-table
                            :data="traveller"
                            stripe
                            border
                            size="small"
                            class="detail-table"
                        >
                            <el-table-column
                                prop="psg_name"
                                label="姓名"
                                min-width="100"
                            ></el-table-column>
                            <el-table-column label="性别" width="72">
                                <template slot-scope="scope">
                                    {{ travellerSexLabel(scope.row) }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="phone"
                                label="手机"
                                min-width="110"
                            ></el-table-column>
                            <el-table-column
                                prop="psg_type_name"
                                label="旅客类型"
                                min-width="90"
                            ></el-table-column>
                            <el-table-column
                                prop="card_type_name"
                                label="证件类型"
                                min-width="100"
                            ></el-table-column>
                            <el-table-column
                                prop="card_no"
                                label="证件号码"
                                min-width="160"
                            ></el-table-column>
                        </el-table>
                    </div>
                    <div v-show="ebkMobile" class="od-m-traveller-list">
                        <div
                            v-for="(trow, tidx) in traveller"
                            :key="travellerRowKey(trow, tidx)"
                            class="od-m-trav-card"
                        >
                            <div class="od-m-trav-name">
                                {{ trow.psg_name || "—" }}
                            </div>
                            <div class="od-m-trav-grid">
                                <div class="od-m-trav-cell">
                                    <span class="od-m-trav-lbl">性别</span>
                                    <span class="od-m-trav-val">{{
                                        travellerSexLabel(trow)
                                    }}</span>
                                </div>
                                <div class="od-m-trav-cell">
                                    <span class="od-m-trav-lbl">手机</span>
                                    <span class="od-m-trav-val">{{
                                        trow.phone || "—"
                                    }}</span>
                                </div>
                                <div class="od-m-trav-cell">
                                    <span class="od-m-trav-lbl">旅客类型</span>
                                    <span class="od-m-trav-val">{{
                                        trow.psg_type_name || "—"
                                    }}</span>
                                </div>
                                <div class="od-m-trav-cell">
                                    <span class="od-m-trav-lbl">证件类型</span>
                                    <span class="od-m-trav-val">{{
                                        trow.card_type_name || "—"
                                    }}</span>
                                </div>
                                <div class="od-m-trav-cell od-m-trav-cell--full">
                                    <span class="od-m-trav-lbl">证件号码</span>
                                    <span class="od-m-trav-val">{{
                                        trow.card_no || "—"
                                    }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <div v-else class="detail-empty fc-sub ta-c py-3">
                    暂无旅客明细
                </div>
            </el-card>
        </div>
        <div class="mt-3">
            <el-card class="box-card" :body-style="bodyStyle">
                <div slot="header" class="clearfix ta-l row ai-c wrap od-card-head">
                    <span><i class="el-icon-date mr-1"></i>价格日历</span>
                    <span
                        v-if="price.length"
                        class="fz-sm fc-sub"
                        :class="ebkMobile ? 'od-card-head__sub--m' : 'ml-2'"
                        >共 {{ price.length }} 天</span
                    >
                </div>
                <template v-if="price.length">
                    <div v-show="!ebkMobile" class="table-scroll-x">
                        <el-table
                            :data="price"
                            stripe
                            border
                            size="small"
                            max-height="360"
                            class="detail-table"
                        >
                            <el-table-column
                                prop="line_time"
                                label="日期"
                                min-width="120"
                            ></el-table-column>
                            <el-table-column label="成本价" min-width="100">
                                <template slot-scope="scope">
                                    <span
                                        v-if="
                                            lineCalendarCostDisplay(scope.row) !==
                                            null
                                        "
                                        class="fc-m"
                                        >￥{{
                                            lineCalendarCostDisplay(scope.row)
                                        }}</span
                                    >
                                    <span v-else class="fc-sub">—</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-show="ebkMobile" class="od-m-price-grid">
                        <div
                            v-for="(prow, pidx) in price"
                            :key="'price-' + pidx + '-' + (prow.line_time || '')"
                            class="od-m-price-card"
                        >
                            <div class="od-m-price-date">{{ prow.line_time }}</div>
                            <div class="od-m-price-cost">
                                <template
                                    v-if="lineCalendarCostDisplay(prow) !== null"
                                >
                                    <span class="fc-m"
                                        >￥{{ lineCalendarCostDisplay(prow) }}</span
                                    >
                                </template>
                                <span v-else class="fc-sub">—</span>
                            </div>
                        </div>
                    </div>
                </template>
                <div v-else class="detail-empty fc-sub ta-c py-3">
                    暂无每日价格
                </div>
            </el-card>
        </div>
        <div class="mt-3">
            <el-card class="box-card" :body-style="bodyStyle">
                <div slot="header" class="clearfix ta-l row ai-c">
                    <span><i class="el-icon-document mr-1"></i>操作日志</span>
                </div>
                <template v-if="logs.length">
                    <div v-show="!ebkMobile" class="table-scroll-x">
                        <el-table
                            :data="logs"
                            stripe
                            border
                            size="small"
                            max-height="360"
                            class="detail-table"
                        >
                            <el-table-column
                                prop="dt"
                                label="时间"
                                min-width="150"
                            ></el-table-column>
                            <el-table-column
                                label="操作人"
                                width="100"
                            >
                                <template slot-scope="scope">
                                    {{ logOperatorPrimary(scope.row) }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="ip"
                                label="IP"
                                width="130"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                label="内容"
                                min-width="280"
                                show-overflow-tooltip
                            >
                                <template slot-scope="scope">
                                    {{ logContentText(scope.row) }}
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-show="ebkMobile" class="od-m-log-list">
                        <div
                            v-for="(lrow, lidx) in logs"
                            :key="'log-' + lidx + '-' + (lrow.dt || '')"
                            class="od-m-log-card"
                        >
                            <div class="od-m-log-head">
                                <span class="od-m-log-time">{{
                                    logTimeShort(lrow.dt)
                                }}</span>
                                <span class="od-m-log-op">{{
                                    logOperatorPrimary(lrow)
                                }}</span>
                            </div>
                            <div class="od-m-log-text">{{
                                logContentText(lrow)
                            }}</div>
                        </div>
                    </div>
                </template>
                <div v-else class="detail-empty fc-sub ta-c py-3">
                    暂无操作日志
                </div>
            </el-card>
        </div>

        <!-- 移动端：确认/驳回用 el-dialog，避免 MessageBox 穿透、残留、样式异常 -->
        <el-dialog
            :title="orderActionDialogTitle"
            :visible.sync="orderActionDialogVisible"
            :width="orderActionDialogWidth"
            append-to-body
            :close-on-click-modal="true"
            :custom-class="orderActionDialogClass"
            center
        >
            <div class="od-action-dialog__body">
                <i class="el-icon-warning od-action-dialog__ico"></i>
                <p class="od-action-dialog__text">{{ orderActionDialogMessage }}</p>
            </div>
            <span slot="footer" class="od-action-dialog__footer">
                <el-button
                    class="od-action-dialog__btn"
                    @click="orderActionDialogVisible = false"
                    >取消</el-button
                >
                <el-button
                    type="primary"
                    class="od-action-dialog__btn"
                    @click="handleMobileOrderActionConfirm"
                    >确定</el-button
                >
            </span>
        </el-dialog>

        <!-- 移动端：填写对单号，替代 $prompt -->
        <el-dialog
            title="提示"
            :visible.sync="caiNoDialogVisible"
            :width="orderActionDialogWidth"
            append-to-body
            :close-on-click-modal="true"
            :custom-class="caiNoDialogClass"
            center
            @closed="onCaiNoDialogClosed"
        >
            <div class="od-caino-dialog__body">
                <p class="od-caino-dialog__hint">请输入新的对单号</p>
                <el-input
                    v-model="caiNoInput"
                    placeholder="对单号"
                    clearable
                    size="medium"
                    class="od-caino-dialog__input"
                    @input="caiNoInputError = ''"
                    @keyup.enter.native="submitCaiNoDialog"
                />
                <p v-if="caiNoInputError" class="od-caino-dialog__err">
                    {{ caiNoInputError }}
                </p>
            </div>
            <span slot="footer" class="od-action-dialog__footer">
                <el-button
                    class="od-action-dialog__btn"
                    @click="caiNoDialogVisible = false"
                    >取消</el-button
                >
                <el-button
                    type="primary"
                    class="od-action-dialog__btn"
                    @click="submitCaiNoDialog"
                    >确定</el-button
                >
            </span>
        </el-dialog>

        <!-- 移动端：填写酒店确认号，替代 $prompt -->
        <el-dialog
            title="提示"
            :visible.sync="psmNoDialogVisible"
            :width="orderActionDialogWidth"
            append-to-body
            :close-on-click-modal="true"
            :custom-class="psmNoDialogClass"
            center
            @closed="onPsmNoDialogClosed"
        >
            <div class="od-caino-dialog__body">
                <p class="od-caino-dialog__hint">请输入新的酒店确认号</p>
                <el-input
                    v-model="psmNoInput"
                    placeholder="酒店确认号"
                    clearable
                    size="medium"
                    class="od-caino-dialog__input"
                    @input="psmNoInputError = ''"
                    @keyup.enter.native="submitPsmNoDialog"
                />
                <p v-if="psmNoInputError" class="od-caino-dialog__err">
                    {{ psmNoInputError }}
                </p>
            </div>
            <span slot="footer" class="od-action-dialog__footer">
                <el-button
                    class="od-action-dialog__btn"
                    @click="psmNoDialogVisible = false"
                    >取消</el-button
                >
                <el-button
                    type="primary"
                    class="od-action-dialog__btn"
                    @click="submitPsmNoDialog"
                    >确定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import qs from "qs";
import { Loading, Message, MessageBox } from "element-ui";
import mobileBreakpoint from "@/mixins/mobileBreakpoint";
import supplierMaintain from "@/mixins/supplierMaintain";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
var options = {
    lock: true,
    text: "Loading",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
};
export default {
    name: "orderDetail",
    components: { PageBreadcrumb },
    mixins: [mobileBreakpoint, supplierMaintain],
    data() {
        return {
            userInfo: {},
            detail: {},
            bodyStyle: {
                padding: "10px",
            },
            traveller: [],
            price: [],
            logs: [],
            /** 防止快速切换订单时，旧接口后返回覆盖当前详情 */
            detailLoadSeq: 0,
            /** 主表接口返回后再显示头部操作按钮，避免首屏未就绪误点 */
            detailLiveStateReady: false,
            /** 解除 MessageBox 穿透屏蔽的定时器 */
            _orderMsgBoxShieldTimer: null,
            _orderMsgBoxPointerLock: false,
            /** 移动端「确认订单 / 驳回订单」对话框 */
            orderActionDialogVisible: false,
            orderActionDialogType: "confirm",
            orderActionDialogTitle: "提示",
            orderActionDialogMessage: "",
            /** 移动端：填写对单号 */
            caiNoDialogVisible: false,
            caiNoInput: "",
            caiNoInputError: "",
            /** 移动端：填写酒店确认号 */
            psmNoDialogVisible: false,
            psmNoInput: "",
            psmNoInputError: "",
        };
    },
    computed: {
        showPendingSupplierActions() {
            return (
                this.detailLiveStateReady &&
                Number(this.detail.order_status) === 1
            );
        },
        showCaiNoticeConfirmBtn() {
            return (
                this.detailLiveStateReady &&
                Number(this.detail.cai_notice) === 1
            );
        },
        descColumns() {
            return this.ebkMobile ? 1 : 2;
        },
        descDirection() {
            return this.ebkMobile ? "vertical" : "horizontal";
        },
        orderActionDialogWidth() {
            return this.ebkMobile ? "92%" : "420px";
        },
        orderActionDialogClass() {
            return this.ebkMobile
                ? "od-order-action-dialog od-order-action-dialog--mobile"
                : "od-order-action-dialog";
        },
        caiNoDialogClass() {
            return this.ebkMobile
                ? "od-order-action-dialog od-order-action-dialog--mobile od-caino-dialog"
                : "od-order-action-dialog od-caino-dialog";
        },
        psmNoDialogClass() {
            return this.ebkMobile
                ? "od-order-action-dialog od-order-action-dialog--mobile od-caino-dialog"
                : "od-order-action-dialog od-caino-dialog";
        },
        pageBreadcrumbItems() {
            return [
                { label: "订单列表", to: { path: "/order" } },
                { label: "订单详情" },
            ];
        },
        settlementTypeText() {
            return this.formatPaymentType(this.detail);
        },
        orderStatusInfo() {
            return this.orderStatusDisplay(this.detail.order_status);
        },
    },
    watch: {
        ebkMobile: function (isMobile) {
            if (!isMobile) {
                this.orderActionDialogVisible = false;
                this.caiNoDialogVisible = false;
                this.psmNoDialogVisible = false;
            }
        },
        $route: {
            immediate: true,
            handler(to) {
                if (to.name !== "orderDetail") {
                    return;
                }
                this.loadOrderDetail();
            },
        },
    },
    beforeDestroy() {
        this.dismissOrderDetailGlobalOverlays();
    },
    deactivated() {
        this.dismissOrderDetailGlobalOverlays();
    },
    methods: {
        /** Element MessageBox 挂载在 body，配合全局样式 .ebk-msgbox--mobile */
        messageBoxMobileOpts(opts) {
            var base = opts || {};
            if (!this.ebkMobile) {
                return base;
            }
            return Object.assign({}, base, {
                customClass: "ebk-msgbox--mobile",
            });
        },
        /**
         * 与 mixin 断点一致；用 matchMedia 即时判断，避免首帧 ebkMobile 未同步。
         */
        orderDetailNeedsMsgTouchShield() {
            if (typeof window === "undefined" || !window.matchMedia) {
                return false;
            }
            return window.matchMedia("(max-width: 992px)").matches;
        },
        armOrderDetailMessageboxTouchShield() {
            if (!this.orderDetailNeedsMsgTouchShield()) {
                return;
            }
            if (typeof document === "undefined") {
                return;
            }
            document.body.classList.add("ebk-order-detail-msgbox-shield");
        },
        releaseOrderDetailMessageboxTouchShieldDeferred() {
            var self = this;
            if (!this.orderDetailNeedsMsgTouchShield()) {
                this._orderMsgBoxPointerLock = false;
                return;
            }
            if (this._orderMsgBoxShieldTimer) {
                clearTimeout(this._orderMsgBoxShieldTimer);
                this._orderMsgBoxShieldTimer = null;
            }
            this._orderMsgBoxShieldTimer = setTimeout(function () {
                if (typeof document !== "undefined") {
                    document.body.classList.remove(
                        "ebk-order-detail-msgbox-shield"
                    );
                }
                self._orderMsgBoxPointerLock = false;
                self._orderMsgBoxShieldTimer = null;
            }, 750);
        },
        clearOrderDetailMessageboxTouchShieldHard() {
            if (this._orderMsgBoxShieldTimer) {
                clearTimeout(this._orderMsgBoxShieldTimer);
                this._orderMsgBoxShieldTimer = null;
            }
            if (typeof document !== "undefined") {
                document.body.classList.remove(
                    "ebk-order-detail-msgbox-shield"
                );
            }
            this._orderMsgBoxPointerLock = false;
        },
        /**
         * MessageBox 挂在 body，keep-alive 返回列表时不会走 beforeDestroy，
         * 必须在 deactivated 里关闭，否则弹层会一直盖在别的页面上。
         */
        dismissOrderDetailGlobalOverlays() {
            this.orderActionDialogVisible = false;
            this.caiNoDialogVisible = false;
            try {
                if (MessageBox && typeof MessageBox.close === "function") {
                    MessageBox.close();
                }
            } catch (e) {
                /* instance 未创建时 close 可能抛错 */
            }
            this.clearOrderDetailMessageboxTouchShieldHard();
        },
        /** 与订单列表 orderStatusDisplay 配色一致 */
        orderStatusDisplay(order_status) {
            var s = Number(order_status);
            if (s === -1) {
                return { text: "待审核", cls: "od-status--pay" };
            }
            if (s === 1) {
                return { text: "待确认", cls: "od-status--pending" };
            }
            if (s === 2) {
                return { text: "已确认", cls: "od-status--ok" };
            }
            if (s === 3) {
                return { text: "确认失败", cls: "od-status--fail" };
            }
            if (s === 4) {
                return { text: "已取消", cls: "od-status--cancel" };
            }
            if (s === 5) {
                return { text: "取消中", cls: "od-status--ing" };
            }
            if (s === 6) {
                return { text: "待支付", cls: "od-status--pay" };
            }
            return { text: "—", cls: "od-status--unknown" };
        },
        /** 按路由 o_id 实时拉取（微信深链经 order-link 页完成供应商校验后进入） */
        loadOrderDetail() {
            const userRaw = this.getToken("userInfo");
            if (!userRaw) {
                return;
            }
            this.userInfo = JSON.parse(userRaw);
            const oId =
                this.$route.query.o_id != null
                    ? String(this.$route.query.o_id)
                    : "";
            if (!oId) {
                this.$message.warning("缺少订单参数");
                this.$router.replace({ path: "/order" });
                return;
            }
            this.fetchDetailFromApi(oId);
        },

        fetchDetailFromApi(oId) {
            var self = this;
            var userRaw = this.getToken("userInfo");
            if (!userRaw) {
                return;
            }
            this.userInfo = JSON.parse(userRaw);
            var loading = Loading.service(options);
            this.$axios
                .soBillDetailList(
                    qs.stringify({
                        o_id: oId,
                        cai_order_no: "",
                        dp_id: this.userInfo.id,
                    })
                )
                .then(function (res) {
                    loading.close();
                    if (!res || !res[0]) {
                        Message.error("订单不存在或无权查看");
                        self.$router.replace({ path: "/order" });
                        return;
                    }
                    var row = Object.assign({}, res[0], { o_id: oId });
                    self.applyDetailFromApi(row);
                })
                .catch(function () {
                    loading.close();
                });
        },

        applyDetailFromApi(row) {
            this.detailLoadSeq += 1;
            const seq = this.detailLoadSeq;
            this.detailLiveStateReady = false;
            this.detail = row;
            this.traveller = [];
            this.price = [];
            this.logs = [];
            this.detailLiveStateReady = true;
            this.soBillWSBillList(seq);
            this.soBillLineList(seq);
            this.fetchOrderLogs(seq);
        },
        // 输入对单号（仅直签自营 zhilian_type=3）
        openCaiNo() {
            if (!this.assertCanMaintain("仅直签自营渠道可修改对单号")) {
                return;
            }
            if (this.orderDetailNeedsMsgTouchShield()) {
                this.caiNoInput =
                    this.detail.cai_order_no != null &&
                    this.detail.cai_order_no !== ""
                        ? String(this.detail.cai_order_no)
                        : "";
                this.caiNoInputError = "";
                this.caiNoDialogVisible = true;
                return;
            }
            this.$prompt("请输入新的对单号", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputPattern: /\S/,
                inputErrorMessage: "对单号不能为空",
            })
                .then(({ value }) => {
                    this.confirmationNumberEdit(value);
                })
                .catch(() => {});
        },
        onCaiNoDialogClosed() {
            this.caiNoInput = "";
            this.caiNoInputError = "";
        },
        submitCaiNoDialog() {
            if (!this.assertCanMaintain("仅直签自营渠道可修改对单号")) {
                return;
            }
            var v = (this.caiNoInput || "").trim();
            if (!v) {
                this.caiNoInputError = "对单号不能为空";
                return;
            }
            this.caiNoInputError = "";
            this.caiNoDialogVisible = false;
            this.confirmationNumberEdit(v);
        },
        // 修改对单号
        confirmationNumberEdit(val) {
            if (!this.assertCanMaintain("仅直签自营渠道可修改对单号")) {
                return;
            }
            Loading.service(options);
            let data = {
                order_no: this.detail.order_no,
                cai_order_no: val,
            };
            this.$axios
                .confirmationNumberEdit(qs.stringify(data))
                .then((res) => {
                    if (res) {
                        this.detail.cai_order_no = val;
                    } else {
                        this.$alert(res.msg, "提示", this.messageBoxMobileOpts({
                            confirmButtonText: "确定",
                            callback: (action) => {},
                        }));
                    }
                    Loading.service(options).close();
                })
                .catch((err) => {
                    Loading.service(options).close();
                });
        },
        // 输入酒店确认号（仅直签自营 zhilian_type=3）
        openPsmNo() {
            if (!this.assertCanMaintain("仅直签自营渠道可修改酒店确认号")) {
                return;
            }
            if (this.orderDetailNeedsMsgTouchShield()) {
                this.psmNoInput =
                    this.detail.psm_no != null && this.detail.psm_no !== ""
                        ? String(this.detail.psm_no)
                        : "";
                this.psmNoInputError = "";
                this.psmNoDialogVisible = true;
                return;
            }
            this.$prompt("请输入新的酒店确认号", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputPattern: /\S/,
                inputErrorMessage: "酒店确认号不能为空",
            })
                .then(({ value }) => {
                    this.psmNoEdit(value);
                })
                .catch(() => {});
        },
        onPsmNoDialogClosed() {
            this.psmNoInput = "";
            this.psmNoInputError = "";
        },
        submitPsmNoDialog() {
            if (!this.assertCanMaintain("仅直签自营渠道可修改酒店确认号")) {
                return;
            }
            var v = (this.psmNoInput || "").trim();
            if (!v) {
                this.psmNoInputError = "酒店确认号不能为空";
                return;
            }
            this.psmNoInputError = "";
            this.psmNoDialogVisible = false;
            this.psmNoEdit(v);
        },
        // 修改酒店确认号
        psmNoEdit(val) {
            if (!this.assertCanMaintain("仅直签自营渠道可修改酒店确认号")) {
                return;
            }
            Loading.service(options);
            let data = {
                order_no: this.detail.order_no,
                psm_no: val,
            };
            this.$axios
                .psmNoEdit(qs.stringify(data))
                .then((res) => {
                    if (res) {
                        this.detail.psm_no = val;
                    } else {
                        this.$alert(res.msg, "提示", this.messageBoxMobileOpts({
                            confirmButtonText: "确定",
                            callback: (action) => {},
                        }));
                    }
                    Loading.service(options).close();
                })
                .catch((err) => {
                    Loading.service(options).close();
                });
        },
        // 供应商确认已知悉：平台侧已取消，仅消掉取消通知
        confirmationCancelEdit() {
            if (this.orderDetailNeedsMsgTouchShield()) {
                this.openMobileOrderActionDialog("cancelConfirm");
                return;
            }
            this.$confirm("该订单已取消，请确认已知悉", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.CancelEdit();
                })
                .catch(() => {});
        },
        // 取消确认
        CancelEdit(){
            let data = {
                order_no: this.detail.order_no,
            };
            Loading.service(options);
            this.$axios
                .confirmationCancelEdit(qs.stringify(data))
                .then((res) => {
                    Loading.service(options).close();
                    if (res) {
                        this.detail.cai_notice = 0;
                        this.fetchOrderLogs(this.detailLoadSeq);
                    }else{
                        this.$alert(res.msg, "提示", this.messageBoxMobileOpts({
                            confirmButtonText: "确定",
                            callback: (action) => {
                            },
                        }));
                    }
                })
                .catch((err) => {
                    Loading.service(options).close();
                });
        },
        /** 操作成功后刷新主表（状态、对单号等） */
        refreshDetailMain(seq) {
            if (seq === undefined) {
                seq = this.detailLoadSeq;
            }
            const oId = this.detail.o_id;
            if (!oId) {
                return;
            }
            this.$axios
                .soBillDetailList(
                    qs.stringify({
                        o_id: oId,
                        cai_order_no: "",
                        dp_id: this.userInfo.id,
                    })
                )
                .then((res) => {
                    if (seq !== this.detailLoadSeq || !res || !res[0]) {
                        return;
                    }
                    const d = res[0];
                    this.detail.cancelpolicy_detail = d.cancelpolicy_detail;
                    if (
                        d.cai_order_no != null &&
                        String(d.cai_order_no).trim() !== ""
                    ) {
                        this.detail.cai_order_no = String(d.cai_order_no).trim();
                    }
                    if (d.psm_no != null && String(d.psm_no).trim() !== "") {
                        this.detail.psm_no = String(d.psm_no).trim();
                    }
                    if (
                        d.payment_type !== undefined &&
                        d.payment_type !== null &&
                        d.payment_type !== ""
                    ) {
                        this.detail.payment_type = d.payment_type;
                    }
                    if (d.order_status !== undefined && d.order_status !== null) {
                        this.detail.order_status = d.order_status;
                    }
                    if (d.cai_notice !== undefined && d.cai_notice !== null) {
                        this.detail.cai_notice = d.cai_notice;
                    }
                })
                .catch(() => {});
        },
        /** hy_order.payment_type：0 记应付账款 1 现金付款 2 预付款付款 */
        formatPaymentType(row) {
            if (!row || row.payment_type === undefined || row.payment_type === null || row.payment_type === "") {
                return "—";
            }
            var pt = Number(row.payment_type);
            if (pt === 0) return "记应付账款";
            if (pt === 1) return "现金付款";
            if (pt === 2) return "预付款付款";
            return "—";
        },
        // 支持 Unix 秒级时间戳或接口返回的 Y-m-d 字符串
        timestampToTime(timestamp) {
            if (timestamp == null || timestamp === "") {
                return "";
            }
            if (
                typeof timestamp === "string" &&
                /^\d{4}-\d{2}-\d{2}/.test(timestamp)
            ) {
                return timestamp.substring(0, 10);
            }
            var date = new Date(Number(timestamp) * 1000);
            let Y = date.getFullYear() + "-";
            let M =
                (date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth() + 1) + "-";
            let D = date.getDate() + " ";
            return Y + M + D;
        },
        travellerSexLabel(row) {
            if (!row) {
                return "—";
            }
            if (row.sex == 1) {
                return "男";
            }
            if (
                row.sex === undefined ||
                row.sex === null ||
                row.sex === ""
            ) {
                return "—";
            }
            return "女";
        },
        travellerRowKey(row, idx) {
            return (
                "trav-" +
                idx +
                "-" +
                (row.psg_name || "") +
                "-" +
                (row.phone || "")
            );
        },
        /**
         * 价格日历仅展示成本：优先 hy_order_line.line_cost；
         * 无成本明细时用订单结算总价 o_fu_money 按间夜均摊（不取 line_price 销售价）。
         */
        lineCalendarCostDisplay(row) {
            if (!row) {
                return null;
            }
            if (row.line_cost != null && row.line_cost !== "") {
                return row.line_cost;
            }
            const nights = Array.isArray(this.price) ? this.price.length : 0;
            const rooms = Number(this.detail.rooms_count);
            const total = Number(this.detail.o_fu_money);
            if (!nights || !rooms || total <= 0 || rooms < 1) {
                return null;
            }
            const per = total / rooms / nights;
            if (!isFinite(per)) {
                return null;
            }
            return Math.round(per * 100) / 100;
        },
        soBillWSBillList(seq) {
            let data = {
                o_id: this.detail.o_id,
            };
            this.$axios
                .soBillWSBillList(qs.stringify(data))
                .then((res) => {
                    if (seq !== this.detailLoadSeq) {
                        return;
                    }
                    this.traveller = res || [];
                })
                .catch((err) => {
                    Loading.service(options).close();
                });
        },
        soBillLineList(seq) {
            let data = {
                o_id: this.detail.o_id,
            };
            this.$axios
                .soBillLineList(qs.stringify(data))
                .then((res) => {
                    if (seq !== this.detailLoadSeq) {
                        return;
                    }
                    this.price = res || [];
                })
                .catch((err) => {
                    Loading.service(options).close();
                });
        },
        logOperatorPrimary(row) {
            if (!row) {
                return "—";
            }
            var name = (row.userName || row.name || "").trim();
            var paren = name.indexOf("（");
            if (paren > 0) {
                name = name.substring(0, paren).trim();
            }
            if (name) {
                return name;
            }
            var login = (row.loginName || row.login_name || "").trim();
            return login || "—";
        },
        logTimeShort(dt) {
            if (!dt) {
                return "—";
            }
            var s = String(dt).trim();
            if (s.length >= 16) {
                return s.substring(5, 16);
            }
            return s;
        },
        logContentText(row) {
            if (!row) {
                return "—";
            }
            var text = (row.content || "").trim();
            if (!text) {
                return "—";
            }
            return text
                .replace(/^开始准备生成子订单[,，]开启事务$/, "确认订单处理中")
                .replace(/^审核平台销售订单[,，]单号[:：]/, "确认订单，单号：")
                .replace(/^驳回审核平台销售订单[,，]单号[:：]/, "驳回订单，单号：");
        },
        fetchOrderLogs(seq) {
            const orderNo = this.detail.order_no;
            if (!orderNo) {
                this.logs = [];
                return;
            }
            let data = {
                order_no: orderNo,
            };
            this.$axios
                .getOrderLog(qs.stringify(data))
                .then((res) => {
                    if (seq !== this.detailLoadSeq) {
                        return;
                    }
                    const list = (res && res.logs) || [];
                    this.logs = Array.isArray(list) ? list : [];
                })
                .catch(() => {
                    if (seq === this.detailLoadSeq) {
                        this.logs = [];
                    }
                });
        },
        openMobileOrderActionDialog(type) {
            this.orderActionDialogType = type;
            if (type === "confirm") {
                this.orderActionDialogMessage = "要确认该订单吗";
            } else if (type === "reject") {
                this.orderActionDialogMessage = "要驳回该订单吗";
            } else if (type === "cancelConfirm") {
                this.orderActionDialogMessage =
                    "该订单已取消，请确认已知悉";
            }
            this.orderActionDialogVisible = true;
        },
        handleMobileOrderActionConfirm() {
            var t = this.orderActionDialogType;
            this.orderActionDialogVisible = false;
            if (t === "confirm") {
                this.sendConfirm();
            } else if (t === "reject") {
                this.rejectOrder();
            } else if (t === "cancelConfirm") {
                this.CancelEdit();
            }
        },
        // 确定订单
        confirmOrder() {
            if (this.orderDetailNeedsMsgTouchShield()) {
                this.openMobileOrderActionDialog("confirm");
                return;
            }
            this.$confirm("要确认该订单吗", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.sendConfirm();
                })
                .catch(() => {});
        },
        // 发送确认订单
        sendConfirm() {
            let data = {
                o_id: this.detail.o_id,
                orderType: "1",
                or_id: "",
            };
            Loading.service(options);
            this.$axios
                .commitSOBill(qs.stringify(data))
                .then((res) => {
                    Loading.service(options).close();
                    if (res) {
                        this.detail.order_status = 2;
                        this.fetchOrderLogs(this.detailLoadSeq);
                    }else{
                        this.$alert(res.msg, "提示", this.messageBoxMobileOpts({
                            confirmButtonText: "确定",
                            callback: (action) => {
                            },
                        }));
                    }
                })
                .catch((err) => {
                    Loading.service(options).close();
                });
        },
        // 确定订单
        confirmOrderNo() {
            if (this.orderDetailNeedsMsgTouchShield()) {
                this.openMobileOrderActionDialog("reject");
                return;
            }
            this.$confirm("要驳回该订单吗", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.rejectOrder();
                })
                .catch(() => {});
        },
        // 驳回订单
        rejectOrder() {
            let data = {
                o_id: this.detail.o_id,
                orderType: "1",
                or_id: "",
            };
            Loading.service(options);
            this.$axios
                .cancelConfirmSOBill(qs.stringify(data))
                .then((res) => {
                    Loading.service(options).close();
                    if (res) {
                        this.detail.order_status = 3;
                        this.fetchOrderLogs(this.detailLoadSeq);
                    }else{
                        this.$alert(res.msg, "提示", this.messageBoxMobileOpts({
                            confirmButtonText: "确定",
                            callback: (action) => {
                            },
                        }));
                    }
                })
                .catch((err) => {
                    Loading.service(options).close();
                });
        },
    },
};
</script>

<style scoped>
.fz-big {
    font-size: 24px;
}

/* 关键字段高亮 */
.od-key-em {
    color: #303133;
    font-weight: 600;
    word-break: break-all;
}
.od-key-money {
    color: #e6a23c;
    font-weight: 700;
    font-size: 15px;
}
.od-key-date {
    color: #409eff;
    font-weight: 600;
}
.od-key-contact {
    color: #303133;
    font-weight: 600;
}

/* 订单状态（与列表 fc-wan / fc-s / fc-e 等语义一致，增加底色更易辨认） */
.od-status-badge {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.5;
}
.od-status--pending {
    color: #e6a23c;
    background: #fdf6ec;
}
.od-status--ok {
    color: #67c23a;
    background: #f0f9eb;
}
.od-status--fail {
    color: #f56c6c;
    background: #fef0f0;
}
.od-status--cancel {
    color: #909399;
    background: #f4f4f5;
}
.od-status--ing {
    color: #e6a23c;
    background: #fdf6ec;
}
.od-status--pay {
    color: #ff6600;
    background: #fff7e6;
}
.od-status--unknown {
    color: #909399;
    background: #f4f4f5;
}
.el-card >>> .el-card__header {
    padding: 12px 14px;
}
.fz-sm {
    font-size: 13px;
}
.detail-table {
    width: 100%;
}
.detail-empty {
    border: 1px dashed #e4e7ed;
    border-radius: 4px;
    background: #fafafa;
}
.py-3 {
    padding-top: 12px;
    padding-bottom: 12px;
}
* {
    word-wrap: break-word;
}

.order-detail-head {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
}
.order-detail-head__title {
    flex: 1 1 auto;
    min-width: 0;
    word-break: break-word;
}
.order-detail-head__actions {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
}
.order-detail-head__btn-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-end;
}
.order-detail-page--mobile .order-detail-head {
    flex-direction: column;
    align-items: stretch;
}
.order-detail-page--mobile .order-detail-head__actions {
    align-items: stretch;
    width: 100%;
}
.order-detail-page--mobile .order-detail-head__btn-row {
    flex-direction: column;
    width: 100%;
}
.order-detail-page--mobile .order-detail-action-btn {
    width: 100%;
    margin: 0 !important;
    min-height: 40px;
}
.order-detail-page--mobile
    .order-detail-head__btn-row
    .order-detail-action-btn
    + .order-detail-action-btn {
    margin-left: 0 !important;
}
.order-detail-page--mobile .fz-big {
    font-size: 18px;
    line-height: 1.35;
}
.od-card-head__sub--m {
    display: block;
    width: 100%;
    margin-top: 6px;
    margin-left: 0 !important;
}
.order-detail-page--mobile .margin-top /deep/ .el-descriptions-row {
    display: block;
}
.order-detail-page--mobile .margin-top /deep/ .el-descriptions-item__cell {
    display: block;
    width: 100% !important;
    border-right: none;
}
.order-detail-page--mobile .margin-top /deep/ .el-descriptions-item__label {
    width: 100% !important;
    display: block;
    text-align: left;
    padding-bottom: 4px;
}
.od-m-traveller-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}
.od-m-trav-card {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 12px 14px;
    background: #fafbfc;
    box-sizing: border-box;
}
.od-m-trav-name {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 10px;
    word-break: break-word;
}
.od-m-trav-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
}
.od-m-trav-cell {
    padding: 8px 10px;
    background: #fff;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    min-width: 0;
    box-sizing: border-box;
}
.od-m-trav-cell--full {
    grid-column: 1 / -1;
}
.od-m-trav-lbl {
    display: block;
    font-size: 11px;
    color: #909399;
    margin-bottom: 4px;
}
.od-m-trav-val {
    font-size: 13px;
    color: #303133;
    font-weight: 500;
    word-break: break-word;
    line-height: 1.35;
}
.od-m-price-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
}
.od-m-price-card {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 10px 12px;
    background: #f6f8fa;
    min-width: 0;
    box-sizing: border-box;
}
.od-m-price-date {
    font-size: 12px;
    color: #909399;
    margin-bottom: 6px;
    word-break: break-word;
}
.od-m-price-cost {
    font-size: 15px;
    font-weight: 600;
    line-height: 1.3;
}
.od-m-log-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.od-m-log-card {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 10px 12px;
    background: #fafbfc;
    box-sizing: border-box;
}
.od-m-log-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 8px;
}
.od-m-log-time {
    flex-shrink: 0;
    font-size: 12px;
    color: #909399;
    line-height: 1.3;
}
.od-m-log-op {
    flex-shrink: 0;
    font-size: 13px;
    font-weight: 600;
    color: #303133;
    line-height: 1.3;
}
.od-m-log-text {
    font-size: 14px;
    color: #303133;
    line-height: 1.55;
    word-break: break-word;
    white-space: pre-wrap;
}
</style>

<!-- MessageBox / $confirm 挂到 body，需全局类名 -->
<style>
/* 穿透：关闭瞬间底层仍会收到 click；整页短时 pointer-events:none（MessageBox 在 body 下不受影响） */
body.ebk-order-detail-msgbox-shield .order-detail-page {
    pointer-events: none !important;
}
.el-message-box__wrapper:has(.ebk-msgbox--mobile) {
    display: flex !important;
    align-items: center;
    justify-content: center;
    padding: max(16px, env(safe-area-inset-top, 0px))
        max(16px, env(safe-area-inset-right, 0px))
        max(16px, env(safe-area-inset-bottom, 0px))
        max(16px, env(safe-area-inset-left, 0px));
    box-sizing: border-box;
}
.el-message-box__wrapper:has(.ebk-msgbox--mobile)::after {
    display: none !important;
}
.ebk-msgbox--mobile.el-message-box {
    display: block !important;
    width: min(400px, calc(100vw - 32px)) !important;
    max-width: min(400px, calc(100vw - 32px)) !important;
    max-height: calc(100vh - 48px);
    max-height: calc(100dvh - 48px);
    margin: 0 auto !important;
    vertical-align: unset !important;
    box-sizing: border-box;
    border-radius: 12px;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}
.ebk-msgbox--mobile .el-message-box__header {
    padding: 16px 16px 6px;
    box-sizing: border-box;
}
.ebk-msgbox--mobile .el-message-box__title {
    font-size: 17px;
    font-weight: 600;
    line-height: 1.4;
    word-break: break-word;
    padding-right: 28px;
}
.ebk-msgbox--mobile .el-message-box__headerbtn {
    top: 14px;
    right: 12px;
}
.ebk-msgbox--mobile .el-message-box__content {
    padding: 8px 16px 4px;
    box-sizing: border-box;
}
.ebk-msgbox--mobile .el-message-box__container {
    display: flex;
    align-items: flex-start;
    box-sizing: border-box;
}
.ebk-msgbox--mobile .el-message-box__status {
    position: relative !important;
    left: auto !important;
    top: auto !important;
    transform: none !important;
    flex-shrink: 0;
    margin-right: 10px;
    font-size: 22px !important;
}
.ebk-msgbox--mobile .el-message-box__status + .el-message-box__message {
    padding-left: 0 !important;
    padding-right: 0 !important;
}
.ebk-msgbox--mobile .el-message-box__message {
    flex: 1;
    min-width: 0;
    padding: 2px 0 6px;
    box-sizing: border-box;
}
.ebk-msgbox--mobile .el-message-box__message p {
    margin: 0;
    font-size: 15px;
    line-height: 1.55;
    color: #606266;
    word-break: break-word;
}
.ebk-msgbox--mobile .el-message-box__btns {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 12px 16px 16px;
    text-align: center !important;
    width: 100%;
    box-sizing: border-box;
    position: sticky;
    bottom: 0;
    background: #fff;
    padding-top: 14px;
    border-top: 1px solid #ebeef5;
    z-index: 2;
}
.ebk-msgbox--mobile .el-message-box__btns .el-button {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    min-height: 44px;
    font-size: 15px;
    border-radius: 8px;
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    touch-action: manipulation;
}
.ebk-msgbox--mobile .el-message-box__btns .el-button + .el-button {
    margin-left: 0 !important;
}
.ebk-msgbox--mobile .el-message-box__input {
    padding: 4px 16px 8px;
    box-sizing: border-box;
}
.ebk-msgbox--mobile .el-message-box__input .el-input__inner {
    min-height: 44px;
    font-size: 15px;
    box-sizing: border-box;
}
.ebk-msgbox--mobile .el-message-box__errormsg {
    padding-top: 6px;
    font-size: 13px;
}

/* 订单详情：移动端确认/驳回用 el-dialog（append-to-body），样式须全局 */
.od-order-action-dialog--mobile.el-dialog {
    margin-top: 8vh !important;
    border-radius: 12px;
    max-height: min(88vh, calc(100dvh - 32px));
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
}
.od-order-action-dialog--mobile .el-dialog__header {
    padding: 16px 16px 10px;
    box-sizing: border-box;
}
.od-order-action-dialog--mobile .el-dialog__title {
    font-size: 17px;
    font-weight: 600;
    line-height: 1.4;
    word-break: break-word;
}
.od-order-action-dialog--mobile .el-dialog__body {
    padding: 8px 16px 12px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
}
.od-order-action-dialog--mobile .od-action-dialog__body {
    display: flex;
    align-items: flex-start;
    gap: 12px;
}
.od-order-action-dialog--mobile .od-action-dialog__ico {
    color: #e6a23c;
    font-size: 22px;
    flex-shrink: 0;
    margin-top: 2px;
}
.od-order-action-dialog--mobile .od-action-dialog__text {
    margin: 0;
    font-size: 15px;
    line-height: 1.55;
    color: #606266;
    word-break: break-word;
}
.od-order-action-dialog--mobile .el-dialog__footer {
    padding: 12px 16px;
    padding-bottom: max(12px, env(safe-area-inset-bottom, 0px));
    border-top: 1px solid #ebeef5;
    box-sizing: border-box;
}
.od-order-action-dialog--mobile .od-action-dialog__footer {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
}
.od-order-action-dialog--mobile .od-action-dialog__footer .el-button {
    width: 100%;
    margin: 0 !important;
    min-height: 44px;
    touch-action: manipulation;
}

/* 订单详情：填写对单号 dialog（与确认订单 dialog 同壳，内容区为输入框） */
.od-order-action-dialog--mobile.od-caino-dialog .el-dialog__body {
    display: block;
}
.od-caino-dialog__body {
    width: 100%;
    box-sizing: border-box;
}
.od-caino-dialog__hint {
    margin: 0 0 12px;
    font-size: 15px;
    color: #606266;
    line-height: 1.5;
}
.od-caino-dialog__input .el-input__inner {
    min-height: 44px;
    font-size: 15px;
    box-sizing: border-box;
}
.od-caino-dialog__err {
    margin: 8px 0 0;
    min-height: 18px;
    font-size: 13px;
    color: #f56c6c;
    line-height: 1.4;
}
</style>


// WEBPACK FOOTER //
// src/components/orderDetail.vue